import { type Filter, type FilterGroup } from './defs';

const createFilters = (init?: Partial<Filter>): Filter => {
  return Object.assign(
    {
      title: '',
      queryKey: null,
      queryValue: '1',
      requestKey: null,
      requestValue: '1',
      pillText: null,
      pillOrder: 0,
      menuOrder: 0,
      hidden: false,
      tag: null,

      type: '',
      options: [],
    },
    init
  );
};

const recipeFilters: FilterGroup = {
  topFilters: [],
  bottomFilters: [
    createFilters({
      title: 'Your Recipes',
      type: 'choose_one',
      menuOrder: 1,
      pillOrder: 12,
      options: [
        createFilters({
          title: 'Saved Recipes',
          menuOrder: 1,
          pillOrder: 1,
          requestKey: 'is_favorite',
          queryKey: 'filter_favorites',
        }),
        createFilters({
          title: 'Recent Recipes',
          menuOrder: 2,
          pillOrder: 2,
          requestKey: 'is_recent',
          queryKey: 'is_recent',
        }),
      ],
    }),
    createFilters({
      title: 'Servings',
      type: 'choose_one',
      menuOrder: 2,
      options: [
        createFilters({
          title: '1 serving',
          type: 'toggle',
          requestKey: 'servings',
          requestValue: '1',
          queryKey: 'servings',
          queryValue: '1',
        }),
        createFilters({
          title: '2 servings',
          type: 'toggle',
          requestKey: 'servings',
          requestValue: '2',
          queryKey: 'servings',
          queryValue: '2',
        }),
        createFilters({
          title: '3 servings',
          type: 'toggle',
          requestKey: 'servings',
          requestValue: '3',
          queryKey: 'servings',
          queryValue: '3',
        }),
        createFilters({
          title: '4 servings',
          type: 'toggle',
          requestKey: 'servings',
          requestValue: '4',
          queryKey: 'servings',
          queryValue: '4',
        }),
        createFilters({
          title: '5 servings',
          type: 'toggle',
          requestKey: 'servings',
          requestValue: '5',
          queryKey: 'servings',
          queryValue: '5',
        }),
      ],
    }),
    createFilters({
      title: 'Dietary Needs',
      type: 'and',
      menuOrder: 2,
      pillOrder: 1,
      pillText: 'Diet',
      options: [
        createFilters({
          title: 'Vegan',
          menuOrder: 1,
          pillOrder: 1,
          requestKey: 'is_vegan',
          queryKey: 'is_vegan',
        }),
        createFilters({
          title: 'Vegetarian',
          menuOrder: 2,
          pillOrder: 2,
          requestKey: 'is_vegetarian',
          queryKey: 'is_vegetarian',
        }),
        createFilters({
          title: 'Pescatarian',
          menuOrder: 3,
          pillOrder: 3,
          requestKey: 'is_pescatarian',
          queryKey: 'is_pescatarian',
        }),
        createFilters({
          title: 'Dairy-Free',
          menuOrder: 4,
          pillOrder: 4,
          requestKey: 'is_dairy_free',
          queryKey: 'is_dairy_free',
        }),
        createFilters({
          title: 'Gluten-Free',
          menuOrder: 5,
          pillOrder: 5,
          requestKey: 'is_gluten_free',
          queryKey: 'is_gluten_free',
        }),
        createFilters({
          title: 'Soy-Free',
          menuOrder: 6,
          pillOrder: 6,
          requestKey: 'is_soy_free',
          queryKey: 'is_soy_free',
        }),
        createFilters({
          title: 'Tree Nut-Free',
          menuOrder: 7,
          pillOrder: 7,
          requestKey: 'is_nut_free',
          queryKey: 'is_nut_free',
        }),
        createFilters({
          title: 'Peanut-Free',
          menuOrder: 8,
          pillOrder: 8,
          requestKey: 'is_peanut_free',
          queryKey: 'is_peanut_free',
        }),
        createFilters({
          title: 'Egg-Free',
          menuOrder: 9,
          pillOrder: 9,
          requestKey: 'is_egg_free',
          queryKey: 'is_egg_free',
        }),
        createFilters({
          title: 'Shellfish-Free',
          menuOrder: 10,
          pillOrder: 10,
          requestKey: 'is_shellfish_free',
          queryKey: 'is_shellfish_free',
        }),
      ],
    }),
    createFilters({
      title: 'Protein',
      type: 'or',
      menuOrder: 3,
      pillOrder: 2,
      options: [
        createFilters({
          title: 'Ground Beef',
          menuOrder: 1,
          pillOrder: 1,
          tag: 802,
          requestKey: 'protein_tags',
          requestValue: '802',
          queryKey: 'protein',
          queryValue: '802',
        }),
        createFilters({
          title: 'Steak',
          menuOrder: 2,
          pillOrder: 2,
          tag: 795,
          requestKey: 'protein_tags',
          requestValue: '795',
          queryKey: 'protein',
          queryValue: '795',
        }),
        createFilters({
          title: 'Bison',
          menuOrder: 3,
          pillOrder: 3,
          tag: 794,
          requestKey: 'protein_tags',
          requestValue: '794',
          queryKey: 'protein',
          queryValue: '794',
        }),
        createFilters({
          title: 'Chicken',
          menuOrder: 4,
          pillOrder: 4,
          tag: 804,
          requestKey: 'protein_tags',
          requestValue: '804',
          queryKey: 'protein',
          queryValue: '804',
        }),
        createFilters({
          title: 'Turkey',
          menuOrder: 5,
          pillOrder: 5,
          tag: 803,
          requestKey: 'protein_tags',
          requestValue: '803',
          queryKey: 'protein',
          queryValue: '803',
        }),
        createFilters({
          title: 'Pork',
          menuOrder: 6,
          pillOrder: 6,
          tag: 3,
          requestKey: 'protein_tags',
          requestValue: '3',
          queryKey: 'protein',
          queryValue: '3',
        }),
        createFilters({
          title: 'Lamb',
          menuOrder: 7,
          pillOrder: 7,
          tag: 16,
          requestKey: 'protein_tags',
          requestValue: '16',
          queryKey: 'protein',
          queryValue: '16',
        }),
        createFilters({
          title: 'Salmon',
          menuOrder: 8,
          pillOrder: 8,
          tag: 801,
          requestKey: 'protein_tags',
          requestValue: '801',
          queryKey: 'protein',
          queryValue: '801',
        }),
        createFilters({
          title: 'Tuna',
          menuOrder: 9,
          pillOrder: 9,
          tag: 796,
          requestKey: 'protein_tags',
          requestValue: '796',
          queryKey: 'protein',
          queryValue: '796',
        }),
        createFilters({
          title: 'Trout',
          menuOrder: 10,
          pillOrder: 10,
          tag: 797,
          requestKey: 'protein_tags',
          requestValue: '797',
          queryKey: 'protein',
          queryValue: '797',
        }),
        createFilters({
          title: 'Whitefish',
          menuOrder: 11,
          pillOrder: 11,
          tag: 798,
          requestKey: 'protein_tags',
          requestValue: '798',
          queryKey: 'protein',
          queryValue: '798',
        }),
        createFilters({
          title: 'Shellfish',
          menuOrder: 12,
          pillOrder: 12,
          tag: 5,
          requestKey: 'protein_tags',
          requestValue: '5',
          queryKey: 'protein',
          queryValue: '5',
        }),
        createFilters({
          title: 'Smoked Fish',
          menuOrder: 13,
          pillOrder: 13,
          tag: 6,
          requestKey: 'protein_tags',
          requestValue: '6',
          queryKey: 'protein',
          queryValue: '6',
        }),
        createFilters({
          title: 'Tofu + Tempeh',
          menuOrder: 14,
          pillOrder: 14,
          tag: 7,
          requestKey: 'protein_tags',
          requestValue: '7',
          queryKey: 'protein',
          queryValue: '7',
        }),
        createFilters({
          title: 'Beans + Lentils',
          menuOrder: 15,
          pillOrder: 15,
          tag: 9,
          requestKey: 'protein_tags',
          requestValue: '9',
          queryKey: 'protein',
          queryValue: '9',
        }),
        createFilters({
          title: "Plant-based 'Meat' Alternatives",
          menuOrder: 16,
          pillOrder: 16,
          tag: 10,
          requestKey: 'protein_tags',
          requestValue: '10',
          queryKey: 'protein',
          queryValue: '10',
        }),
      ],
    }),
    createFilters({
      title: 'Nutrition',
      type: 'and',
      menuOrder: 4,
      pillOrder: 3,
      options: [
        createFilters({
          title: '<500 Calories',
          menuOrder: 1,
          pillOrder: 1,
          tag: 65,
          requestKey: 'nutrition_tags',
          requestValue: '65',
          queryKey: 'max_calories',
          queryValue: '500',
        }),
        createFilters({
          title: '500-650 Calories',
          menuOrder: 2,
          pillOrder: 2,
          tag: 660,
          requestKey: 'nutrition_tags',
          requestValue: '660',
          queryKey: 'max_calories',
          queryValue: '650',
        }),
        createFilters({
          title: 'Carb Conscious (<30g)',
          menuOrder: 3,
          pillOrder: 3,
          tag: 23,
          requestKey: 'nutrition_tags',
          requestValue: '23',
          queryKey: 'is_carb_conscious',
        }),
        createFilters({
          title: 'Less Sugar (<4g)',
          menuOrder: 4,
          pillOrder: 4,
          tag: 24,
          requestKey: 'nutrition_tags',
          requestValue: '24',
          queryKey: 'is_less_sugar',
        }),
        createFilters({
          title: 'High Protein (>25g)',
          menuOrder: 5,
          pillOrder: 5,
          tag: 25,
          requestKey: 'nutrition_tags',
          requestValue: '25',
          queryKey: 'is_high_protein',
        }),
        createFilters({
          title: 'Less Sodium (<500mg)',
          menuOrder: 6,
          pillOrder: 6,
          tag: 26,
          requestKey: 'nutrition_tags',
          requestValue: '26',
          queryKey: 'is_less_sodium',
        }),
        createFilters({
          title: 'Anti-inflammatory',
          menuOrder: 7,
          pillOrder: 7,
          tag: 242,
          requestKey: 'nutrition_tags',
          requestValue: '242',
          queryKey: 'is_anti_inflammatory',
        }),
      ],
    }),
    createFilters({
      title: 'Sort',
      type: 'choose_one',
      menuOrder: 5,
      pillOrder: 6,
      options: [
        createFilters({
          title: 'Personalized (Default)',
          pillText: 'Personalized',
          menuOrder: 1,
          pillOrder: 1,
          requestKey: 'sort_by_default',
          queryKey: 'sort_by_default',
        }),
        createFilters({
          title: 'Credits',
          menuOrder: 2,
          pillOrder: 2,
          requestKey: 'sort',
          requestValue: 'points',
          queryKey: 'sort_by_points',
        }),
      ],
    }),
    createFilters({
      title: 'Spice Level',
      type: 'or',
      menuOrder: 6,
      pillOrder: 7,
      pillText: 'Spice',
      options: [
        createFilters({
          title: 'No Heat',
          menuOrder: 1,
          pillOrder: 1,
          tag: 19,
          requestKey: 'spicy_levels',
          requestValue: '0',
          queryKey: 'spicy_levels',
          queryValue: '0',
        }),
        createFilters({
          title: 'Mild',
          menuOrder: 2,
          pillOrder: 2,
          tag: 20,
          requestKey: 'spicy_levels',
          requestValue: '1',
          queryKey: 'spicy_levels',
          queryValue: '1',
        }),
        createFilters({
          title: 'Medium',
          menuOrder: 3,
          pillOrder: 3,
          tag: 21,
          requestKey: 'spicy_levels',
          requestValue: '2',
          queryKey: 'spicy_levels',
          queryValue: '2',
        }),
        createFilters({
          title: 'Hot',
          menuOrder: 4,
          pillOrder: 4,
          tag: 22,
          requestKey: 'spicy_levels',
          requestValue: '3',
          queryKey: 'spicy_levels',
          queryValue: '3',
        }),
      ],
    }),
    createFilters({
      title: 'Featured',
      type: 'split_or',
      menuOrder: 7,
      pillOrder: 9999,
      options: [
        createFilters({
          title: 'Breakfast-Friendly',
          type: 'toggle',
          menuOrder: 4,
          pillOrder: 4,
          tag: 47,
          requestKey: 'occasion_tags',
          requestValue: '47',
          queryKey: 'is_breakfast_friendly',
        }),
        createFilters({
          title: 'Lunch-Friendly',
          type: 'toggle',
          menuOrder: 5,
          pillOrder: 5,
          tag: 48,
          requestKey: 'occasion_tags',
          requestValue: '48',
          queryKey: 'is_lunch_friendly',
        }),
        createFilters({
          title: 'Kid-Friendly',
          type: 'toggle',
          menuOrder: 13,
          pillOrder: 15,
          tag: 175,
          requestKey: 'occasion_tags',
          requestValue: '175',
          queryKey: 'is_kid_friendly',
        }),
        createFilters({
          title: 'Newest Additions',
          pillText: 'New',
          type: 'toggle',
          menuOrder: 10,
          pillOrder: 8,
          tag: 17,
          requestKey: 'is_new',
          queryKey: 'is_new',
        }),
        createFilters({
          title: "Chef's Kitchen",
          type: 'toggle',
          menuOrder: 11,
          pillOrder: 9,
          tag: 4234,
          requestKey: 'tag',
          requestValue: '4234',
          queryKey: 'is_chefs_kitchen',
        }),
        createFilters({
          title: 'Top Picks',
          type: 'toggle',
          menuOrder: 12,
          pillOrder: 10,
          requestKey: 'is_featured',
          queryKey: 'is_featured',
        }),
        createFilters({
          title: 'Most Popular',
          type: 'toggle',
          menuOrder: 14,
          pillOrder: 14,
          tag: 17,
          requestKey: 'is_popular',
          queryKey: 'is_popular',
        }),
        createFilters({
          title: 'In Season',
          type: 'toggle',
          menuOrder: 16,
          pillOrder: 16,
          tag: 135,
          requestKey: 'is_seasonal',
          queryKey: 'is_seasonal',
        }),
        createFilters({
          title: 'Community Recipes',
          type: 'toggle',
          menuOrder: 17,
          pillOrder: 17,
          tag: 196,
          requestKey: 'marketing_tags',
          requestValue: '196',
          queryKey: 'is_marketing',
          queryValue: '196',
        }),
        createFilters({
          title: `High Fiber`,
          type: 'toggle',
          menuOrder: 1,
          pillOrder: 3.5,
          tag: 125,
          requestKey: 'marketing_tags',
          requestValue: '125',
          queryKey: 'is_marketing',
          queryValue: '1',
          hidden: false,
        }),
        createFilters({
          title: 'Game Day Eats',
          type: 'toggle',
          menuOrder: 19,
          pillOrder: 18,
          tag: 197,
          requestKey: 'marketing_tags',
          requestValue: '197',
          queryKey: 'is_marketing',
          queryValue: '3',
          hidden: true,
        }),
        createFilters({
          title: 'Cold Weather Comfort',
          type: 'toggle',
          menuOrder: 20,
          pillOrder: 19,
          tag: 200,
          requestKey: 'marketing_tags',
          requestValue: '200',
          queryKey: 'is_marketing',
          queryValue: '4',
          hidden: true,
        }),
      ],
    }),
    createFilters({
      title: 'Cook Time',
      type: 'choose_one',
      menuOrder: 8,
      pillOrder: 10,
      options: [
        createFilters({
          title: '5 Minutes Or Less',
          pillText: '<5 Minutes',
          menuOrder: 1,
          pillOrder: 1,
          tag: 187,
          requestKey: 'max_cooking_time',
          requestValue: '5',
          queryKey: 'max_cooking_time',
          queryValue: '5',
        }),
        createFilters({
          title: '10 Minutes Or Less',
          pillText: '<10 Minutes',
          menuOrder: 2,
          pillOrder: 2,
          tag: 188,
          requestKey: 'max_cooking_time',
          requestValue: '10',
          queryKey: 'max_cooking_time',
          queryValue: '10',
        }),
        createFilters({
          title: '20 Minutes Or Less',
          pillText: '<20 Minutes',
          menuOrder: 2,
          pillOrder: 3,
          tag: 189,
          requestKey: 'max_cooking_time',
          requestValue: '20',
          queryKey: 'max_cooking_time',
          queryValue: '20',
        }),
      ],
    }),
    createFilters({
      title: 'Cooking Appliances',
      type: 'or',
      menuOrder: 9,
      pillOrder: 11,
      options: [
        createFilters({
          title: 'None',
          menuOrder: 1,
          pillOrder: 1,
          tag: 177,
          requestKey: 'tool_tags',
          requestValue: '177',
          queryKey: 'tool_tags',
          queryValue: '177',
        }),
        createFilters({
          title: 'Stovetop',
          menuOrder: 2,
          pillOrder: 2,
          tag: 156,
          requestKey: 'tool_tags',
          requestValue: '156',
          queryKey: 'tool_tags',
          queryValue: '156',
        }),
        createFilters({
          title: 'Oven',
          menuOrder: 3,
          pillOrder: 3,
          tag: 207,
          requestKey: 'tool_tags',
          requestValue: '207',
          queryKey: 'tool_tags',
          queryValue: '207',
        }),
        createFilters({
          title: 'Microwave',
          menuOrder: 4,
          pillOrder: 4,
          tag: 153,
          requestKey: 'tool_tags',
          requestValue: '153',
          queryKey: 'tool_tags',
          queryValue: '153',
        }),
        createFilters({
          title: 'Air Fryer',
          menuOrder: 5,
          pillOrder: 5,
          tag: 152,
          requestKey: 'tool_tags',
          requestValue: '152',
          queryKey: 'tool_tags',
          queryValue: '152',
        }),
        createFilters({
          title: 'Slow Cooker',
          menuOrder: 6,
          pillOrder: 6,
          tag: 155,
          requestKey: 'tool_tags',
          requestValue: '155',
          queryKey: 'tool_tags',
          queryValue: '155',
        }),
        createFilters({
          title: 'Grill',
          menuOrder: 7,
          pillOrder: 7,
          tag: 151,
          requestKey: 'tool_tags',
          requestValue: '151',
          queryKey: 'tool_tags',
          queryValue: '151',
        }),
      ],
    }),
  ],
  query: '',
};

// Remove hidden props once before exporting
recipeFilters.bottomFilters = recipeFilters.bottomFilters.filter(
  (f) => !f.hidden
);
recipeFilters.bottomFilters.forEach((f) => {
  f.options = f.options.filter((o) => !o.hidden);
});

export { recipeFilters };
